import { useEffect, useRef } from 'react'
import { Tab, Tabs as TabContainer, TabContainerInner, TabsType } from './Styled'
import classNames from 'classnames'

interface TabOption {
  id: string
  name: string
}

interface Props {
  options?: TabOption[]
  value?: string
  type?: string
  align?: 'spread' | 'center' | 'left' | 'right'
  onChange?: (val: string) => void
  className?: string
  autoScroll?: boolean
  [key: string]: any
}

export default function Tabs({
  options = [],
  value = '',
  type = TabsType.Fill,
  align = 'center',
  onChange = (val) => {},
  className,
  autoScroll = true,
  ...props
}: Props) {
  useEffect(() => {
    if (autoScroll) {
      elements.current[value]?.scrollIntoView({ behavior: 'smooth', inline: 'center' })
    }
  })

  const elements = useRef<Record<string, HTMLElement | null>>({})
  const onRef = (id: string, el: HTMLElement | null) => {
    elements.current[id] = el
  }

  return (
    <TabContainer align={align} className={classNames(className, 'no-prevent-swipe')} {...props}>
      <TabContainerInner>
        {options.map((t) => (
          <Tab
            key={t.id}
            type={type}
            className={value === t.id ? 'active' : ''}
            onClick={() => onChange(t.id)}
            ref={(el) => onRef(t.id, el)}
          >
            {t.name}
          </Tab>
        ))}
      </TabContainerInner>
    </TabContainer>
  )
}
